import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalSameFilesFINComponent } from './Resource/modal-same-files-fin/modal-same-files-fin.component';

@NgModule({
  declarations: [ModalSameFilesFINComponent],
  imports: [CommonModule],
  exports: [ModalSameFilesFINComponent]
})
export class LibraryFinSharedModule { }
